module.exports = __webpack_public_path__ + "img/4800.1ce7d5db.jpg";